// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1xgnz6y-MuiStack-root {
  overflow: hidden !important;
  padding-top: 0px !important;
}

.css-eb89ea {
  overflow: hidden !important;
  padding-top: 0px !important;
}

.css-1xgnz6y-MuiStack-root > .MuiTextField-root,
.css-1xgnz6y-MuiStack-root > .MuiPickersTextField-root {
  width: 196px;
  height: 30px;
  background-color: white;
}
.css-1xgnz6y-MuiStack-root > .MuiTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root,
.css-1xgnz6y-MuiStack-root > .MuiPickersTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  height: 30px;
  font-size: 14px;
  min-width: 190px !important;
}
.css-1xgnz6y-MuiStack-root > .MuiTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-i4bv87-MuiSvgIcon-root,
.css-1xgnz6y-MuiStack-root > .MuiPickersTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root .css-i4bv87-MuiSvgIcon-root {
  height: 17px;
}

.css-eb89ea > .MuiTextField-root,
.css-eb89ea > .MuiPickersTextField-root {
  width: 196px;
  height: 30px;
  background-color: white;
}
.css-eb89ea > .MuiTextField-root .css-1bn53lx,
.css-eb89ea > .MuiPickersTextField-root .css-1bn53lx {
  height: 30px;
  font-size: 14px;
  min-width: 190px !important;
}
.css-eb89ea > .MuiTextField-root .css-1bn53lx .css-vubbuv,
.css-eb89ea > .MuiPickersTextField-root .css-1bn53lx .css-vubbuv {
  height: 17px !important;
}

.addNewPolicyTextField .css-1xgnz6y-MuiStack-root > .MuiTextField-root, .addNewPolicyTextField .css-1xgnz6y-MuiStack-root > .MuiPickersTextField-root {
  width: 294px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.08);
}
.addNewPolicyTextField .css-1xgnz6y-MuiStack-root > .MuiTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root, .addNewPolicyTextField .css-1xgnz6y-MuiStack-root > .MuiPickersTextField-root .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  height: 60px;
}
.addNewPolicyTextField .css-eb89ea > .MuiTextField-root, .addNewPolicyTextField .css-eb89ea > .MuiPickersTextField-root {
  width: 294px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.08);
}
.addNewPolicyTextField .css-eb89ea > .MuiTextField-root .css-1bn53lx, .addNewPolicyTextField .css-eb89ea > .MuiPickersTextField-root .css-1bn53lx {
  height: 60px;
}

.css-1rtg91x-MuiDateCalendar-root {
  width: 293px;
}`, "",{"version":3,"sources":["webpack://./src/shared-component/Calender/style.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,2BAAA;AACJ;;AAGA;EACI,2BAAA;EACA,2BAAA;AAAJ;;AAGA;;EAEI,YAAA;EACA,YAAA;EACA,uBAAA;AAAJ;AAEI;;EACI,YAAA;EACA,eAAA;EACA,2BAAA;AACR;AACQ;;EACI,YAAA;AAEZ;;AAIA;;EAEI,YAAA;EACA,YAAA;EACA,uBAAA;AADJ;AAGI;;EACI,YAAA;EACA,eAAA;EACA,2BAAA;AAAR;AAEQ;;EACI,uBAAA;AACZ;;AAOI;EACI,YAAA;EACA,YAAA;EACA,qCAAA;AAJR;AAMQ;EACI,YAAA;AAJZ;AASI;EACI,YAAA;EACA,YAAA;EACA,qCAAA;AAPR;AASQ;EACI,YAAA;AAPZ;;AAYA;EACI,YAAA;AATJ","sourcesContent":[".css-1xgnz6y-MuiStack-root {\r\n    overflow: hidden !important;\r\n    padding-top: 0px !important;\r\n}\r\n\r\n//For deployment\r\n.css-eb89ea {\r\n    overflow: hidden !important;\r\n    padding-top: 0px !important;\r\n}\r\n\r\n.css-1xgnz6y-MuiStack-root>.MuiTextField-root,\r\n.css-1xgnz6y-MuiStack-root>.MuiPickersTextField-root {\r\n    width: 196px;\r\n    height: 30px;\r\n    background-color: white;\r\n\r\n    .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\r\n        height: 30px;\r\n        font-size: 14px;\r\n        min-width: 190px !important;\r\n\r\n        .css-i4bv87-MuiSvgIcon-root {\r\n            height: 17px;\r\n        }\r\n    }\r\n}\r\n\r\n//For deployment\r\n.css-eb89ea>.MuiTextField-root,\r\n.css-eb89ea>.MuiPickersTextField-root {\r\n    width: 196px;\r\n    height: 30px;\r\n    background-color: white;\r\n\r\n    .css-1bn53lx {\r\n        height: 30px;\r\n        font-size: 14px;\r\n        min-width: 190px !important;\r\n\r\n        .css-vubbuv {\r\n            height: 17px !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.addNewPolicyTextField {\r\n\r\n    .css-1xgnz6y-MuiStack-root>.MuiTextField-root, .css-1xgnz6y-MuiStack-root>.MuiPickersTextField-root {\r\n        width: 294px;\r\n        height: 60px;\r\n        background-color: rgb(0 0 0 / 8%);\r\n\r\n        .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\r\n            height: 60px;\r\n        }\r\n    }\r\n\r\n    //For Deployment\r\n    .css-eb89ea>.MuiTextField-root, .css-eb89ea>.MuiPickersTextField-root {\r\n        width: 294px;\r\n        height: 60px;\r\n        background-color: rgb(0 0 0 / 8%);\r\n\r\n        .css-1bn53lx {\r\n            height: 60px;\r\n        }\r\n    }\r\n}\r\n\r\n.css-1rtg91x-MuiDateCalendar-root {\r\n    width: 293px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
